/**
 * Client mirror of supabase/functions/_shared/threadWidgets.ts
 */

export type ThreadWidget =
  | {
    type: "confirm_action";
    id: string;
    label: string;
    tool: string;
    input: Record<string, unknown>;
    variant?: "primary" | "destructive";
    description?: string;
  }
  | {
    type: "undo_action";
    id: string;
    label: string;
    tool: string;
    input: Record<string, unknown>;
    description?: string;
  }
  | {
    type: "address_capture";
    id: string;
    label: string;
    submit_label?: string;
    placeholder?: string;
  }
  | {
    type: "vendor_picker";
    id: string;
    label: string;
    vendors: Array<{
      vendor_partner_id: string;
      vendor_name: string;
      sample_sku_id?: string;
    }>;
  }
  | {
    type: "celebration_picker";
    id: string;
    label: string;
    celebrations: Array<{
      celebration_id: string;
      label: string;
      type: string;
      date: string;
    }>;
  }
  | {
    type: "budget_summary";
    period_label: string;
    allocated_aud: number;
    spent_aud: number;
    scheduled_aud: number;
    adjustments_aud: number;
    remaining_aud: number;
    cadence_type: string;
  }
  | {
    type: "team_member_highlight";
    team_member_id: string;
    name: string;
    message?: string;
  };

export interface WidgetActionRequest {
  tool: string;
  input: Record<string, unknown>;
  address?: string;
}

export function parseThreadWidgets(raw: unknown): ThreadWidget[] {
  if (!Array.isArray(raw)) return [];
  const out: ThreadWidget[] = [];
  for (const item of raw) {
    if (!item || typeof item !== "object") continue;
    const w = item as Record<string, unknown>;
    if (w.type === "confirm_action" && typeof w.tool === "string") {
      out.push(w as ThreadWidget);
    } else if (w.type === "undo_action" && typeof w.tool === "string") {
      out.push(w as ThreadWidget);
    } else if (w.type === "address_capture") {
      out.push(w as ThreadWidget);
    } else if (w.type === "vendor_picker" && Array.isArray(w.vendors)) {
      out.push(w as ThreadWidget);
    } else if (w.type === "celebration_picker" && Array.isArray(w.celebrations)) {
      out.push(w as ThreadWidget);
    } else if (w.type === "budget_summary") {
      out.push(w as ThreadWidget);
    } else if (w.type === "team_member_highlight" && typeof w.team_member_id === "string") {
      out.push(w as ThreadWidget);
    }
  }
  return out.slice(0, 6);
}

export function formatAud(amount: number): string {
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
  }).format(amount);
}
